<button (click)="open()" data-test-selector="open-reset-onboarding-modal">
  <div class="headerbar-action" data-test-selector="open-reset-onboarding-modal">
    <div class="headerbar-action-icon">info</div>
  </div>
</button>
